import { Injectable } from '@angular/core';
import { GtmService } from '../../../../shared/services/gtm.service';
import { Categorie, Evenement } from '@oel/js-cybermetrie';
import { Store } from '@ngxs/store';
import { TypeCapaciteEnum } from '../../constants/type-capacite.enum';
import { CapaciteSelectors } from '../../capacite.selectors';

@Injectable({
  providedIn: 'root'
})
export class CapaciteCybermetrieService {
  constructor(private readonly _gtm: GtmService, private readonly _store: Store) {}

  private get typeCapacite() {
    switch (this._store.selectSnapshot(CapaciteSelectors.typeCapacite)) {
      case TypeCapaciteEnum.PME_SECONDAIRE:
        return 'residence secondaire';
      case TypeCapaciteEnum.PME_REMPLACER:
        return 'remplacer residence';
      case TypeCapaciteEnum.AUTRE:
      default:
        return 'premiere maison';
    }
  }

  pushFormulaireEvent(action: string, dimensionsPersonnalisees: Record<string, string> = {}) {
    this._gtm.pushEvent(
      {
        event: Evenement.InterractionsPages,
        category: Categorie.Formulaire,
        action,
        label: `frm - capacite financiere - ${this.typeCapacite}`
      },
      new Map(Object.entries(dimensionsPersonnalisees))
    );
  }

  pushClickEvent(label: string, dimensionsPersonnalisees: Record<string, string> = {}) {
    this._gtm.pushEvent(
      {
        event: Evenement.InterractionsPages,
        category: 'Parcours habitation',
        action: 'Clic',
        label: `capacite financiere - ${this.typeCapacite} - ${label}`
      },
      new Map(Object.entries(dimensionsPersonnalisees))
    );
  }

  pushTiroirEvent(label: string) {
    this._gtm.pushEvent({
      event: Evenement.InterractionsPages,
      category: 'Tiroirs',
      action: 'Ouverture',
      label: `capacite financiere - ${this.typeCapacite} - ${label}`
    });
  }
}
